import {
    broadcast,
    onBroadcast,
} from "../api"
import App from './App'
import { fireEvent } from '../common/util'
import Webview from "./component/native/visible/Webview";
import Container from "./component/visible/Container";
let nativeComponentMap = {}
document.addEventListener('nativeComponentCreated', function (event) {
    const { id, instance } = event.param
    nativeComponentMap[id] = instance
})
/*

const Message111 =  {
    broadcast,
    onBroadcast,
    // 收到父视图发来的消息 父视图调用webview的postMessage方法后，子视图通过该方法监听
    // 由于不支持指定eventName，暂时考虑弃用
    /!*onSuperViewEmitMessage(cb) {
        onBroadcast('webviewPostMessage', (event)=>{
            console.log('收到postmessage', event, App, App.rootWebview)
            const { data={} } = event
            if(data.id === App.rootWebview.id){
                cb && cb(data.data)
            }
        })
    },*!/
    //收到子视图向父视图发来的消息  onSubViewEmitMessage
    onSubViewEmitMessage(eventName, cb) {
        onBroadcast('webviewEmitMessage', (event)=>{
            // console.log('收到EmitMessage onSubViewEmitMessage ===>',event,nativeComponentMap,nativeComponentMap[event.data.id],eventName,event.data.eventName)
            const { data={} } = event
            if(nativeComponentMap[data.id] && data.id!==App.rootWebviewId && eventName===data.eventName){
                console.warn('收到指定的 ==》 EmitMessage', event,nativeComponentMap,nativeComponentMap[data.id],eventName,data.eventName)
                cb && cb(data.data)
            }
        })
    },
    //向父视图发送消息  emitMessageToSuperView
    emitMessageToSuperView(eventName, params={}) {
        const _params = {
            id: App.rootWebview.id,
            eventName,
            data: {
                ...params
            }
        }
        console.log('emitMessageToSuperView',_params)
        return broadcast('webviewEmitMessage', _params)
    },
    //向特定视图发送消息 （使用onSuperViewEmitMessage方法接收消息）
    emitMessageToView(view, eventName, params={}) {
        const _params = {
            id: view.id,
            eventName,
            data: {
                ...params
            }
        }
        return broadcast('emitMessageToView', _params)
    },
    //收到父视图发来的消息 （接收使用emitMessageToView方法发送的消息）
    onSuperViewEmitMessage(eventName, cb) {
        onBroadcast('emitMessageToView', (event)=>{
            console.log(App)
            // const isMe = event.data.id === App.rootWebview.id ? '我的' : '不是我的'
            // const responseStatus = event.data.id === App.rootWebview.id && eventName===event.data.eventName ? '响应' : '不响应'
            // console.log('收到emitMessageToView', isMe, responseStatus, event)
            const { data={} } = event
            if(data.id === App.rootWebview.id && eventName===data.eventName){
                cb && cb(data.data)
            }
        })
    }

}

// 触发指定view中的js事件 （与onSuperViewEmitMessage方法有所区别，注意区别）
Message111.fireViewJsEvent =  (function(){
    Message111.onSuperViewEmitMessage('fireViewJsEvent', event=>{
        fireEvent(data.eventName, data.data)
    })

    return function(view, eventName, params={}) {
        const _params = {
            eventName,
            data: {
                ...params
            }
        }
        return Message.emitMessageToView(view, 'fireViewJsEvent', _params)
    }
})()

*/





const EventManager = (function () {
    const eventMap = {}
    window.addEventListener('message', (e) => {
        console.log("iframe 获取到 message====>", e, location.href)
        const { eventName, data, __from__, __directionalMessage__ } = e.data
        const cbList = eventMap[eventName]
        if (cbList) {
            cbList.forEach(cb => {
                cb({
                    data,
                    __from__,
                    __directionalMessage__
                })
            })
        }
    })
    return {
        addEventListener(eventName, cb) {
            if (('string' === typeof eventName) && ('function' === typeof cb)) {
                eventMap[eventName] = eventMap[eventName] || []
                eventMap[eventName].push(cb)
            } else {
                console.warn('参数错误')
            }
        },
        //给所有子iframe发送信息
        fireAllSubViews(eventName, data, from = 'superView') {
            const ifrs = document.querySelectorAll('iframe.container-iframe')
            ifrs.forEach(ifr => {
                ifr.contentWindow.postMessage({
                    eventName,
                    data,
                    __from__: 'superView'
                }, '*')
            })
        },
        //给特定iframe发送信息
        fireView(contentWindow, eventName, data, from) {
            contentWindow && contentWindow.postMessage({
                eventName,
                data,
                // 标记为定向消息，该消息发给特定视图，接收方不必再将消息向外广播转发
                __directionalMessage__: true,
                __from__: from
            }, '*')
        }
    }
})()



/*

const Message =  {
    broadcast(eventName, data) {
        //如果当前是顶层iframe，遍历所有子iframe发送信息
        if(window.top === window){
            EventManager.fireAllSubViews(eventName, data)
        }else{ //如果非顶层iframe，把消息转发给顶层iframe
            //top.postMessage({eventName, data}, '*')
            EventManager.fireView(window.top, eventName, data)
        }
    },
    onBroadcast(eventName, cb) {
        //执行当前iframe所有广播监听
        EventManager.addEventListener(eventName, (data)=>{
            cb(data)
            if(!data.__directionalMessage__){
                //遍历所有子iframe 触发onBroadcast
                EventManager.fireAllSubViews(eventName, data)
            }
        })
    },
    //向特定视图发送消息 （使用onSuperViewEmitMessage方法接收消息）
    emitMessageToView(view, eventName, data={}) {
        const ifr = view.getElement()
        ifr &&
        ifr.contentWindow  &&
        EventManager.fireView(ifr.contentWindow, eventName, data, 'superView')
    },
    //向父视图发送消息  emitMessageToSuperView
    emitMessageToSuperView(eventName, data={}) {
        const contentWindow = window.parent
        if(window.parent!==window){
            EventManager.fireView(contentWindow, eventName, data, 'subView')
        }
    }
}
*/





class Message {
    constructor() {
    }

    broadcast(eventName, data) {
        //如果当前是顶层iframe，遍历所有子iframe发送信息
        if (window.top === window) {
            EventManager.fireAllSubViews(eventName, data)
        } else { //如果非顶层iframe，把消息转发给顶层iframe
            //top.postMessage({eventName, data}, '*')
            EventManager.fireView(window.top, eventName, data)
        }
    }

    onBroadcast(eventName, cb) {
        //执行当前iframe所有广播监听
        EventManager.addEventListener(eventName, (data) => {
            cb(data)
            if (!data.__directionalMessage__) {
                //遍历所有子iframe 触发onBroadcast
                EventManager.fireAllSubViews(eventName, data)
            }
        })
    }

    //向特定视图发送消息 （使用onSuperViewEmitMessage方法接收消息）
    emitMessageToView(view, eventName, data = {}) {
        const ifr = view.getElement()
        ifr &&
            ifr.contentWindow &&
            EventManager.fireView(ifr.contentWindow, eventName, data, 'superView')
    }

    //向父视图发送消息  emitMessageToSuperView
    emitMessageToSuperView(eventName, data = {}) {
        const contentWindow = window.parent
        if (window.parent !== window) {
            EventManager.fireView(contentWindow, eventName, data, 'subView')
        }
    }
}


class WebviewMessage extends Message {
    constructor() {
        super()
    }

}


class IframeMessage extends Message {
    constructor() {
        super()
    }

    broadcast(eventName, data) {
        //如果当前是顶层iframe，遍历所有子iframe发送信息
        if (window.top === window) {
            EventManager.fireAllSubViews(eventName, data)
        } else { //如果非顶层iframe，把消息转发给顶层iframe
            //top.postMessage({eventName, data}, '*')
            EventManager.fireView(window.top, eventName, data)
        }
    }

    onBroadcast(eventName, cb) {
        //执行当前iframe所有广播监听
        EventManager.addEventListener(eventName, (data) => {
            cb(data.data)
            console.log('向该视图发送onBroadcast信息 ===>>', eventName, location.href)
            if (!data.__directionalMessage__) {
                //遍历所有子iframe 触发onBroadcast
                EventManager.fireAllSubViews(eventName, data)
            }
        })
    }

    //考虑删除
    onSubViewEmitMessage(eventName, cb) {
        return this.onBroadcast(eventName, cb)
    }

    //考虑删除
    onSuperViewEmitMessage(eventName, cb) {
        return this.onBroadcast(eventName, cb)
    }

    //向特定视图发送消息 （使用onSuperViewEmitMessage方法接收消息）
    emitMessageToView(view, eventName, data = {}) {
        const ifr = view.getElement()
        ifr &&
            ifr.contentWindow &&
            EventManager.fireView(ifr.contentWindow, eventName, data, 'superView')
    }

    //向父视图发送消息  emitMessageToSuperView
    emitMessageToSuperView(eventName, data = {}) {
        const contentWindow = window.parent
        if (window.parent !== window) {
            EventManager.fireView(contentWindow, eventName, data, 'subView')
        }
    }
}


class MessageProxy extends Message {
    constructor(...args) {
        super(...args)
        this.iframeMsg = new IframeMessage()
        this.webviewMsg = new WebviewMessage()
    }

    callByProxy(view, fnName, args) {
        if (view instanceof Webview) {
            this.webviewMsg[fnName](...args)
        } else if (view instanceof Container) {
            this.iframeMsg[fnName](...args)
        } else {
            console.warn('无法向该视图发送信息', view)
        }
    }

    broadcast(...args) {
        this.iframeMsg.broadcast(...args)
        this.webviewMsg.broadcast(...args)
    }

    onBroadcast(...args) {
        this.iframeMsg.onBroadcast(...args)
        //this.webviewMsg.onBroadcast(...args)
    }

    //向特定视图发送消息 （使用onSuperViewEmitMessage方法接收消息）
    emitMessageToView(...args) {
        const [view, eventName, data = {}] = args
        this.callByProxy(view, 'emitMessageToView', args)
    }

    //向父视图发送消息  emitMessageToSuperView
    //如果当前为非顶层window视图（iframe），emitMessageToSuperView操作发送给父window视图
    //如果当前是顶层window视图，则emitMessageToSuperView操作发送给父webview视图
    emitMessageToSuperView(...args) {
        if (window.parent !== window) {
            console.log('iframeMsg 向父视图发送消息', args, window.location.href)
            this.iframeMsg.emitMessageToSuperView(...args)
        } else {
            console.log('webviewMsg 向父视图发送消息', args, window.location.href)
            this.webviewMsg.emitMessageToSuperView(...args)
        }
    }

    //考虑删除
    onSubViewEmitMessage(eventName, cb) {
        return this.onBroadcast(eventName, (data) => {
            console.log('onSubViewEmitMessage 收到父视图发送消息', eventName, event, window.location.href)
            cb(data)
        })
    }
    //考虑删除
    onSuperViewEmitMessage(...args) {
        return this.onBroadcast(...args)
    }
}









export default new MessageProxy()